import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";

import PillarForm from "shared/components/pillar-form/PillarForm";

const HubCheckoutPaymentDetailsForm = () => {
  const { checkoutError, hubPaymentTypes } = useHubCheckoutContext();
  return (
    <section aria-labelledby="payment-heading">
      <div id="payment-heading" className="text-subheader pb-1">
        Payment Details
      </div>
      {hubPaymentTypes.credit_card ? (
        <>
          <div className="pb-2">
            <PillarForm.TextInput
              label="Full Name"
              name="fullName"
              testid="payment-fullname-input"
              placeholder="Enter Full Name"
            />
          </div>
          <PillarForm.TextInput
            label="Card Number"
            name="cardNumber"
            testid="payment-card-number-input"
            placeholder="0000 0000 0000 0000"
            className="pt-2"
          />
          <div className="grid grid-cols-2 gap-2 pt-2">
            <PillarForm.ExpirationDateInput
              label="Exp. Date"
              name="expirationDate"
              testid="payment-expiration-date-input"
              placeholder="MM/YY"
              additionalClasses="w-full min-w-0"
              className="w-full"
            />
            <PillarForm.TextInput
              label="CVC"
              name="cvc"
              testid="payment-cvc-input"
              placeholder="CVC"
              additionalClasses="w-full min-w-0"
              className="w-full"
            />
          </div>
          {checkoutError && (
            <div
              data-testid="hub-checkout-error-message"
              className="text-status-danger"
            >
              {checkoutError}
            </div>
          )}
        </>
      ) : (
        <div className="text-status-danger">
          Credit card payments are disabled. Please contact the society
          administrator.
        </div>
      )}
    </section>
  );
};
export default HubCheckoutPaymentDetailsForm;
